export const subscribeToPushNotifications = async (userId, companyId) => {
    try {
        if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
            console.warn('Push notifications are not supported in this browser');
            return false;
        }

        /* 
        let registration = await navigator.serviceWorker.getRegistration();
        if (!registration) {
            registration = await navigator.serviceWorker.register('/service-worker.js');
        }
        */
        const registration = await navigator.serviceWorker.getRegistration();
        if (!registration) return false;

        const permission = await Notification.requestPermission();
        if (permission !== 'granted') {
            console.warn('Permission denied for push notifications');
            return false;
        }

        const response = await fetch('/api/notifications/vapidPublicKey');
        const { publicKey } = await response.json();
        const convertedVapidKey = urlBase64ToUint8Array(publicKey);

        const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: convertedVapidKey
        });

        const res = await fetch('/api/notifications/subscribe', {
            method: 'POST',
            body: JSON.stringify({ subscription, userId, companyId }),
            headers: {
                'content-type': 'application/json'
            }
        });

        if (res.ok) {
            console.log('Successfully subscribed to push notifications');
            localStorage.setItem('stock_push_enabled', 'true');
            localStorage.removeItem('stock_push_disabled');
            return true;
        } else {
            console.error('Failed to save subscription on server');
            return false;
        }

    } catch (err) {
        console.error('Failed to subscribe to push notification', err);
        return false;
    }
};

export const unsubscribeFromPushNotifications = async () => {
    try {
        if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
            return false;
        }

        const registration = await navigator.serviceWorker.getRegistration();
        if (!registration) return false;

        const subscription = await registration.pushManager.getSubscription();
        if (!subscription) {
            localStorage.setItem('stock_push_disabled', 'true');
            return true; // Already unsubscribed
        }

        const endpoint = subscription.endpoint;

        // Unsubscribe from browser
        const successful = await subscription.unsubscribe();
        if (!successful) return false;

        localStorage.removeItem('stock_push_enabled');
        localStorage.setItem('stock_push_disabled', 'true');

        // Remove from our backend
        const res = await fetch('/api/notifications/unsubscribe', {
            method: 'POST',
            body: JSON.stringify({ endpoint }),
            headers: {
                'content-type': 'application/json'
            }
        });

        return res.ok;
    } catch (err) {
        console.error('Failed to unsubscribe', err);
        return false;
    }
};

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}
